import React, { useState, useEffect } from "react";
import "../../styles/dashboard/BotsIPTable.css";

function BotsIPTable() {
  const [bots, setBots] = useState([]);
  const [loading, setLoading] = useState(true);
  const [filter, setFilter] = useState("all");
  const [tweetAuthorCountry, setTweetAuthorCountry] = useState(null);

  useEffect(() => {
    fetchTweetAuthorCountry();
    fetchBots();
  }, []);

  const fetchTweetAuthorCountry = async () => {
    try {
      const res = await fetch("https://api.anti-bot.ai/api/latest-tweet");
      const data = await res.json();
      if (data.success && data.tweet?.author?.country_code) {
        setTweetAuthorCountry(data.tweet.author.country_code);
      }
    } catch {}
  };

  const fetchBots = async () => {
    try {
      const res = await fetch("https://api.anti-bot.ai/api/bots-with-ip");
      const data = await res.json();
      if (data.success) setBots(data.bots);
      setLoading(false);
    } catch {
      setLoading(false);
    }
  };

  const getFilteredBots = () => {
    if (filter === "local") {
      return bots.filter(b => b.country_code === tweetAuthorCountry);
    }
    if (filter === "international") {
      return bots.filter(b => b.country_code !== tweetAuthorCountry);
    }
    return bots;
  };

  const getRiskLevel = (risk) => {
    if (risk >= 70) return { cls: "risk-high", label: "HIGH", icon: "⚠" };
    if (risk >= 50) return { cls: "risk-medium", label: "MEDIUM", icon: "▲" };
    return { cls: "risk-low", label: "LOW", icon: "✓" };
  };


  if (loading) {
    return (
      <div className="bots-ip-table">
        <div className="loading">
          <div className="spinner"></div>
          <p>טוען נתונים...</p>
        </div>
      </div>
    );
  }

  return (
    <div className="bots-ip-table">
      <div className="table-header">
        <h2>זיהוי כתובות IP</h2>
{/* 
        <div className="filters">
          <button className={filter==="all"?"active":""} onClick={()=>setFilter("all")}>
            הכל ({bots.length})
          </button>
          <button className={filter==="local"?"active":""} onClick={()=>setFilter("local")} disabled={!tweetAuthorCountry}>
            מקומי
          </button>
          <button className={filter==="international"?"active":""} onClick={()=>setFilter("international")} disabled={!tweetAuthorCountry}>
            בינלאומי
          </button>
        </div> */}
      </div>

      <div className="table-container">
        <table>
          <thead>
            <tr>
              <th>סיכון</th>
              <th>משתמש</th>
              <th>מיקום</th>
              <th>IP</th>
            </tr>
          </thead>
          <tbody>
            {getFilteredBots().map((bot, i) => {
              const score = bot.risk_score || 0;
              const level = getRiskLevel(score);

              return (
                <tr key={i}>
<td className="risk-score">
  <div className={`risk-pill ${level.cls}`}>
    <span className="risk-icon">{level.icon}</span>
    <span>{level.label}</span>
  </div>
</td>


                  <td className="username">
                    <strong>{bot.name}</strong>
                    <span>@{bot.username}</span>
                  </td>

                  <td className="location">{bot.location}</td>

                  <td className="ip">
                    <code>{bot.country_ip}</code>
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
    </div>
  );
}

export default BotsIPTable;
